import React, { useEffect, useState } from 'react'
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    TableContainer,
    Table,
    Thead,
    Tr,
    Th,
    Tbody,

} from '@chakra-ui/react'
import TableRow from './TableRow';
import { ConfirmPickUp } from '../Utils/ApiCalls';
import moment from 'moment';


export default function HistoryRequest({ isOpen, onClose, singleData }) {

    console.log("singleData history" , singleData)

    



    const PickUpBtn = async (id)=>{
        try {
          
            let result = await ConfirmPickUp(id);
            if(result.status === true){
                alert("Confirmed and Collected successfully")
                onClose()
            }else{
                alert(result.msg)
                onClose()
            }
            console.log("result", result);
           
            
        } catch (e) {
  
            
        }
    }

    useEffect(() => {

    }, [isOpen]);

    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered scrollBehavior={"inside"} size={"xl"}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader> {singleData[0]?.staffname} Request History</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <TableContainer mt="32px" mb="64px" overflowX="auto" color="#fff"

                    >
                        <Table variant='simple' size='sm'>
                            <Thead>
                                <Tr>
                                    <Th >S/N</Th>
                                    <Th >Name</Th>
                                    <Th >Quantity</Th>
                                    <Th >Created Date</Th>
                                    <Th >Status</Th>
                                    


                                </Tr>
                            </Thead>
                            <Tbody>

                            {
                                singleData && (
                                    singleData?.map((item, i) => (
                                        <TableRow
                                            type={"historyRequest"}
                                            key={i}
                                            color="#000"
                                            sn={i + 1}
                                            productName={item?.productname}
                                            dateReceived={moment(item?.createdAt).format("DD/MM/YYY")}
                                            status={item?.status}
                                            qty={item?.qtyrequested}
                                            

                                        />
                                    ))
                                )
                                    
                                }
                            </Tbody>

                        </Table>
                    </TableContainer>
                </ModalBody>

                <ModalFooter>


                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}
